export default "__VITE_ASSET__BqQIBZQW__"